var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    id: "food",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#faa41a",
    d: "M13.004 7.377a1.25 1.25 0 0 0 1.25-1.238 1.25 1.25 0 0 0-1.227-1.262M12.896 9.865a1.25 1.25 0 0 1-1.25-1.238 1.25 1.25 0 0 1 1.227-1.262M13.004 12.365a1.25 1.25 0 0 0 1.25-1.238 1.25 1.25 0 0 0-1.227-1.262m4.977-2.488a1.25 1.25 0 0 0 1.25-1.238 1.25 1.25 0 0 0-1.227-1.262M17.896 9.865a1.25 1.25 0 0 1-1.25-1.238 1.25 1.25 0 0 1 1.227-1.262M18.004 12.365a1.25 1.25 0 0 0 1.25-1.238 1.25 1.25 0 0 0-1.227-1.262M8.391 7.377a1.25 1.25 0 0 0 1.25-1.238 1.25 1.25 0 0 0-1.226-1.262M8.284 9.865a1.25 1.25 0 0 1-1.25-1.238A1.25 1.25 0 0 1 8.26 7.365M8.391 12.365a1.25 1.25 0 0 0 1.25-1.238 1.25 1.25 0 0 0-1.226-1.262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#383747",
    d: "M8.878 27.123h8.998v-2.976c-1.917.846-3.034.978-4.588 1.01-1.943.04-3.26-.296-4.41-.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faa41a",
    stroke: "#383747",
    d: "M24.702 16.349c-1.68 6.274-8.101 9.997-14.375 8.316a11.72 11.72 0 0 1-8.3-8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#383747",
    d: "M2.021 14.344h22.685v2.059H2.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#383747",
    d: "M16.674 14.338c7.8.308 5.839-5.25 11.604-5.752.57-.05.87-.061 1.67-.01l.03-.01c-.995-.592-2.829-1.594-4.36-1.169-.783.218-2.003 1.06-2.82 2.665-2.057 4.504-4.06 4.267-5.69 4.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    d: "M21.474 18.116c-.708 2.16-2.603 3.66-4.803 4.068"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.9922513540755021625637c8d32ac2f9.svg";
export { ForwardRef as ReactComponent };